import { init, setTrackingConsent } from "@jsq/observability";
import { type dgEventGlobalThis, type Preferences } from "common/utils/o11y/types";

const runtimeGlobal = globalThis as dgEventGlobalThis;

const receivePrefs = (preferences: Preferences) => {
  const performanceEnabled = preferences.consentPreferences.cookieOptions.find(
    (option) => option.gtm_key === "dg-category-performance",
  )?.isEnabled;
  if (performanceEnabled) {
    setTrackingConsent("granted");
  } else {
    setTrackingConsent("not-granted");
  }
};

export const initObservability = ({ appName }: { appName: string | undefined }) => {
  runtimeGlobal.dgEvent?.push({
    event: "preference_callback",
    params: receivePrefs,
  });
  runtimeGlobal.dgEvent?.push({
    event: "initial_preference_callback",
    params: receivePrefs,
  });

  init({
    applicationId: __DATADOG_RUM_APP_ID__,
    clientToken: __DATADOG_RUM_CLIENT_TOKEN__,
    serviceName: appName ? `main/${appName}` : undefined,
    version: __JSQ_COMMIT_HASH__,
    trackingConsent: runtimeGlobal.dgEvent ? "not-granted" : "granted",
  });
};
